import * as React from 'react';
import _throttle from 'lodash/throttle';
import {convertHexToRGBA} from '../../../lib/color-utils';

type AnimatedBackgroundColorProps = {
  backgroundColor: string;
  children: React.ReactNode;
  colorKey?: any;
};

const changeBackgroundColor = (ref: React.MutableRefObject<any>, hexColor: string, colorKey?: any) => {
  const element: any = ref.current;
  if (element) {
    const scrollPosition = window.scrollY;
    const viewportHeight = window.innerHeight / 2;
    const section = element.offsetTop - viewportHeight;
    const sectionHeight = element.offsetTop + element.offsetHeight - viewportHeight;
    const isScrolledToItem = scrollPosition >= section && scrollPosition <= sectionHeight;
    const rgbColor = convertHexToRGBA(hexColor, 1, 'rgb');
    const bodyBgColor = document.body.style.backgroundColor.split(' ').join('');

    if (isScrolledToItem) {
      if (colorKey)
        document.body.id = `colorKey-${colorKey}`;

      document.body.style.backgroundColor = rgbColor;
    } else if (bodyBgColor === rgbColor && (colorKey ? document.body.id === `colorKey-${colorKey}` : true)) {
      document.body.style.backgroundColor = 'white';
    }
  }
};

const AnimatedBackgroundColor: React.FC<AnimatedBackgroundColorProps> = props => {
  const ref = React.useRef();
  React.useEffect(() => {
    document.body.classList.add('animatedBackgroundColor');
    changeBackgroundColor(ref, props.backgroundColor);
    const scrollHandler = _throttle(
      () => changeBackgroundColor(ref, props.backgroundColor, props.colorKey),
      300
    );
    window.addEventListener('scroll', scrollHandler);

    return () => {
      document.body.classList.remove('animatedBackgroundColor');
      document.body.style.backgroundColor = 'inherit';
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  return React.cloneElement(props.children as any, {ref});
};

export default AnimatedBackgroundColor;
